import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [token, setToken] = useState('');
  const [requestMode, setRequestMode] = useState(false);
  const [email, setEmail] = useState('');
  const [requestSent, setRequestSent] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (t) {
      setToken(t);
    } else {
      setRequestMode(true);
    }
  }, []);

  const handleRequest = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Enter your email'); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/request-password-reset', { email });
      setRequestSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error('Password must be at least 8 characters'); return; }
    if (password !== confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', { token, password });
      setDone(true);
      toast.success('Password reset! You can now log in.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-login-container">
      <div className="login-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      <div className="login-content animate-in">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <div className="logo-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                </svg>
              </div>
              <h1 className="login-title">Reset Password</h1>
              <p className="login-subtitle">
                {requestMode ? 'Enter your email to receive a reset link' : 'Set a new password for your account'}
              </p>
            </div>
          </div>

          {/* Request mode: just email */}
          {requestMode && !requestSent && (
            <form onSubmit={handleRequest} className="login-form">
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-input"
                  value={email}
                  onChange={e => setEmail(e.target.value.toLowerCase())}
                  placeholder="your@email.com"
                  autoFocus
                />
              </div>
              <button type="submit" className={`login-button ${loading ? 'loading' : ''}`} disabled={loading}>
                {loading ? <><div className="spinner"></div>Sending...</> : 'Send Reset Link'}
              </button>
              <div style={{ textAlign: 'center', marginTop: '12px' }}>
                <a href="/" style={{ color: '#6b7280', fontSize: '13px' }}>Back to login</a>
              </div>
            </form>
          )}

          {requestMode && requestSent && (
            <div style={{ padding: '24px', textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📧</div>
              <p style={{ color: '#374151', marginBottom: '16px' }}>
                If that email exists, we've sent a reset link. Check your inbox.
              </p>
              <a href="/" style={{ color: '#6b7280', fontSize: '13px' }}>Back to login</a>
            </div>
          )}

          {/* Reset mode: new password */}
          {!requestMode && !done && (
            <form onSubmit={handleReset} className="login-form">
              <div className="form-group">
                <label className="form-label">New password</label>
                <input
                  type="password"
                  className="form-input"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm password</label>
                <input
                  type="password"
                  className="form-input"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="Repeat your password"
                />
              </div>
              <button type="submit" className={`login-button ${loading ? 'loading' : ''}`} disabled={loading}>
                {loading ? <><div className="spinner"></div>Resetting...</> : 'Reset Password'}
              </button>
            </form>
          )}

          {done && (
            <div style={{ padding: '24px', textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
              <p style={{ marginBottom: '16px', color: '#374151' }}>Password reset successfully.</p>
              <a href="/" className="login-button" style={{ display: 'inline-block', textDecoration: 'none' }}>
                Go to Login
              </a>
            </div>
          )}

          <div className="login-footer">
            <p>© 2024 Chatbot Admin. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
